module.exports = __webpack_public_path__ + "AvertaStd-LightItalic.svg?a61de488b94a923610b598fb426283cc";